// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___G4II3","root__icon":"style-module__root__icon___ViZUm"};
    if(module.hot) {
      // 1729151130909
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  